import component from './component'

export default {
    path: '/forgotpassword',
    name: 'forgotPassword',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/account/forgotPassword/index.js